import { createRootRoute, createRoute, createRouter, Outlet, redirect } from "@tanstack/react-router";
import { Calendar, Users } from "lucide-react";
import { AppShell } from "./AppShell";
import { MailRoute } from "../features/mail/MailRoute";
import { SettingsView } from "../features/settings/SettingsView";
import { ChatView } from "../features/chat/ChatView";
import { ScheduledView } from "../features/compose/ScheduledView";
import { Placeholder } from "../features/placeholder/Placeholder";
import { LoginView } from "../features/auth/LoginView";

const root = createRootRoute({ component: Outlet });

const login = createRoute({ getParentRoute: () => root, path: "/login", component: LoginView });
const shell = createRoute({ getParentRoute: () => root, id: "shell", component: AppShell });

const index = createRoute({ getParentRoute: () => shell, path: "/", beforeLoad: () => { throw redirect({ to: "/mail/$folder", params: { folder: "inbox" } }); } });
const mail = createRoute({ getParentRoute: () => shell, path: "/mail/$folder", component: MailRoute });
const calendar = createRoute({
  getParentRoute: () => shell,
  path: "/calendar",
  component: () => (
    <Placeholder icon={<Calendar />} title="Calendar">
      Day, week, month and agenda views with your calendars arrive in Phase 5.
    </Placeholder>
  ),
});
const contacts = createRoute({
  getParentRoute: () => shell,
  path: "/contacts",
  component: () => (
    <Placeholder icon={<Users />} title="Contacts">
      Your address books, groups and vCard import arrive in Phase 6.
    </Placeholder>
  ),
});
const chat = createRoute({ getParentRoute: () => shell, path: "/chat", component: ChatView });
const chatChannel = createRoute({ getParentRoute: () => shell, path: "/chat/$channelId", component: ChatView });
const scheduled = createRoute({ getParentRoute: () => shell, path: "/scheduled", component: ScheduledView });
const settings = createRoute({ getParentRoute: () => shell, path: "/settings", component: SettingsView });
const settingsSection = createRoute({ getParentRoute: () => shell, path: "/settings/$section", component: SettingsView });

export const router = createRouter({ routeTree: root.addChildren([login, shell.addChildren([index, mail, scheduled, chat, chatChannel, calendar, contacts, settings, settingsSection])]), defaultPreload: "intent" });

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
